import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function FormStat({
  label,
  value,
  highlight = false,
}: {
  label: string;
  value: ReactNode;
  highlight?: boolean;
}) {
  return (
    <div
      className={cn(
        "rounded-lg border px-2.5 py-2.5",
        highlight
          ? "border-primary/20 bg-primary/10 shadow-sm"
          : "border-border/60 bg-muted/35"
      )}
    >
      <p className="text-[9px] font-semibold uppercase tracking-wide text-muted-foreground">
        {label}
      </p>
      <p
        className={cn(
          "mt-0.5 text-[13px] font-bold tabular-nums tracking-tight",
          highlight ? "text-primary" : "text-foreground"
        )}
      >
        {value}
      </p>
    </div>
  );
}
